import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { Building2, ChevronDown, ChevronUp, AlertCircle } from "lucide-react";

const ClientInfoSection = ({
  isOpen,
  onOpenChange,
  clientInfo,
  setClientInfo,
  validUntil,
  setValidUntil
}) => {
  return (
    <Collapsible open={isOpen} onOpenChange={onOpenChange}>
      <Card>
        <CollapsibleTrigger asChild>
          <CardHeader className="cursor-pointer hover:bg-slate-50 transition-colors py-3">
            <div className="flex items-center justify-between">
              <CardTitle className="text-sm flex items-center gap-2">
                <Building2 className="w-4 h-4" />
                Información del Cliente
                {clientInfo.client_company && (
                  <span className="font-normal text-slate-500">
                    - {clientInfo.client_company}
                  </span>
                )}
              </CardTitle>
              {isOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
            </div>
          </CardHeader>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <CardContent className="pt-0">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              <div>
                <Label className="text-xs">Empresa</Label>
                <Input
                  value={clientInfo.client_company || ""}
                  onChange={(e) => setClientInfo({...clientInfo, client_company: e.target.value})}
                  placeholder="Nombre de empresa"
                  className="h-8"
                  data-testid="client-company-input"
                />
              </div>
              <div>
                <Label className="text-xs">Contacto</Label>
                <Input
                  value={clientInfo.client_contact || ""}
                  onChange={(e) => setClientInfo({...clientInfo, client_contact: e.target.value})}
                  placeholder="Persona de contacto"
                  className="h-8"
                  data-testid="client-contact-input"
                />
              </div>
              <div>
                <Label className="text-xs">Teléfono</Label>
                <Input
                  value={clientInfo.client_phone || ""}
                  onChange={(e) => setClientInfo({...clientInfo, client_phone: e.target.value})}
                  placeholder="+51 999 999 999"
                  className="h-8"
                  data-testid="client-phone-input"
                />
              </div>
              <div className="md:col-span-2">
                <Label className="text-xs">Dirección</Label>
                <Input
                  value={clientInfo.client_address || ""}
                  onChange={(e) => setClientInfo({...clientInfo, client_address: e.target.value})}
                  placeholder="Dirección completa"
                  className="h-8"
                  data-testid="client-address-input"
                />
              </div>
              <div>
                <Label className="text-xs">Email</Label>
                <Input
                  value={clientInfo.client_email || ""}
                  onChange={(e) => setClientInfo({...clientInfo, client_email: e.target.value})}
                  placeholder="cliente@empresa.com"
                  className="h-8"
                  data-testid="client-email-input"
                />
              </div>
              <div>
                <Label className="text-xs flex items-center gap-1">
                  <AlertCircle className="w-3 h-3 text-orange-500" />
                  Válido Hasta
                </Label>
                <Input
                  type="date"
                  value={validUntil || ""}
                  onChange={(e) => setValidUntil(e.target.value)}
                  className="h-8"
                  data-testid="valid-until-input"
                />
              </div>
            </div>
          </CardContent>
        </CollapsibleContent>
      </Card>
    </Collapsible>
  );
};

export default ClientInfoSection;
